<template lang="pug">
  div
    divider(:label="conversa.assuntoDescricao ? conversa.assuntoDescricao : '-'")
    div.mt-1.padding-info(v-if="conversa.mensagemList && conversa.mensagemList.length > 0")
      el-row
        el-collapse()
          el-collapse-item(
            v-for="msg in conversa.mensagemList",
            :key="msg.id",
            :name='msg.id',
          )
            template(slot="title")
              div.lineTable.flex.title.full-width.tableList
                span {{ msg.remetente.pessoaFisica ? msg.remetente.pessoaFisica.nome : msg.remetente.pessoaJuridica ? msg.remetente.pessoaJuridica.razaoSocial : ' - '}}
                span &nbsp-&nbsp
                span {{ formataDataHora(msg.dataEnviada) }} &nbsp
            el-row.margin-top(v-if="msg.dataLimiteResposta")
              p
                b Data de Vencimento:
                span &nbsp {{ formataData(msg.dataLimiteResposta) }}
            el-row.margin-top
              p(v-html="msg.conteudo")

            app-download-arquivo(
              v-for="anexo in msg.anexoList"
              :key="anexo.id"
              :arquivo="anexo"
              @download="download(anexo)"
            )
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'

import Divider from '@/screens/arrecadacao/components/Divider'
import AppDownloadArquivo from '@/components/AppDownloadArquivo'
import FileHelper from '@/utils/fileHelper'

export default {
  components: {
    Divider,
    AppDownloadArquivo,
    FileHelper
  },
  props: {
    idConversa: {
      type: Number | String,
      required: true
    },
    voltar: {
      type: String,
      required: true
    }
  },
  async mounted () {
    if (!this.idConversa) {
      this.$router.push({ name: this.voltar })
      return
    }
    this.conversa = await this.findById(this.$route.params.idConversa)
    this.$emit('statusChanged', this.conversa.status)
    this.$emit('conversa', this.conversa)
  },
  data () {
    return {
      conversa: {}
    }
  },
  methods: {
    ...mapActions({
      findById: 'conversas/findById',
      downloadDocumentos: 'download/download'
    }),
    formataDataHora (data) {
      return moment(data).format('DD/MM/YYYY HH:mm')
    },
    formataData (data) {
      return moment(data).format('DD/MM/YYYY')
    },
    async download (anexo) {
      const arquivo = await this.downloadDocumentos(anexo)

      FileHelper.saveFile(arquivo, anexo.nome)
    }
  }
}
</script>

<style lang="scss" scoped>
.label {
  font-weight: 600;
  margin-right: 10px;
}

span {
  font-size: 15px;
}

.padding-info {
  padding: 0 1rem 0 1rem;
}

.full-width {
  width: -webkit-fill-available;
}

.col {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

@media (max-width: 780px) {
  .lineTable {
    line-height: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/components/comunicacao/InformacoesConversa.vue